const messageTypeMaintenance = 0; // messages to establish the ws connection (sub to channel etc)
const messageTypeServer = 1; // messages that are send to the server to be handled here
const messageTypeBroadcast = 2; // messages that are broadcast to all other users in the same room

// maintenance event codes:
const subscribeEvent = 0;
const unsubscribeEvent = 1;
const errorEvent = 2;

export {
	messageTypeMaintenance,
	messageTypeServer,
	messageTypeBroadcast,
	subscribeEvent,
	unsubscribeEvent,
	errorEvent,
};
